import { render, staticRenderFns } from "./addWorkType.vue?vue&type=template&id=406b9b03&scoped=true"
import script from "./addWorkType.vue?vue&type=script&lang=js"
export * from "./addWorkType.vue?vue&type=script&lang=js"
import style0 from "./addWorkType.vue?vue&type=style&index=0&id=406b9b03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406b9b03",
  null
  
)

export default component.exports